module.exports = __webpack_public_path__ + "static/media/7.03f073ef.jpg";